import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  Text,
  ActivityIndicator,
  Image,
  TouchableOpacity,
  Alert,
} from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import {
  Button,
  CheckBox,
} from 'react-native-elements';
import { ifIphoneX } from 'react-native-iphone-x-helper';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientUnauthenticated, AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import CreatePaidLease from '../../q/CreatePaidLease';
import CheckMyLease from '../../q/CheckMyLease';
import QueryMyLeases from '../../q/QueryMyLeases';
import App from '../../modules/data/App';
import Publisher from '../../modules/data/Publisher';
import AppBadge from '../../components/apps/AppBadge';
import PublisherBadge from '../../components/apps/PublisherBadge';
import AORTypes from '../../types';

import version from '../../version.json';
import styles from '../../styles';
import { translate } from '../../locales/i18n';
import methods from '../../modules/payment';

class Purchase extends React.Component {
  static updateStateOnAppChanges(app) {
    app.postProcess();

    console.log('Create publisher from the app:');
    console.log(app);
    const publisher = Publisher.createFromApp(app);

    const endpointsOrdered = [];
    // console.log('uuids to render:');
    app.pp.endpointIds.forEach((uuid) => {
      // console.log(uuid);

      for (let i = 0; i < app.pp.endpoints.length; i += 1) {
        if (app.data.endpoints[i].uuid === uuid) {
          endpointsOrdered.push(app.data.endpoints[i]);
          break;
        }
      }
    });

    let latAvg = 20.0;
    let lonAvg = 20.0;
    let latDelta = 60;
    let lonDelta = 60;

    try {
      latAvg = app.pp.bounds.latAvg;
      lonAvg = app.pp.bounds.lonAvg;
      latDelta = app.pp.bounds.latDelta;
      lonDelta = app.pp.bounds.lonDelta;
    } catch (_e) {
      let latMin = 300.0;
      let latMax = -300.0;
      let lonMin = 300.0;
      let lonMax = -300;

      if (app.data && app.data.endpoints) {
        if (app.data.endpoints.length === 1) {
          latMin = app.data.endpoints[0].lat;
          latMax = app.data.endpoints[0].lat;
          lonMin = app.data.endpoints[0].lon;
          lonMax = app.data.endpoints[0].lon;

          latDelta = 0.0922;
          lonDelta = 0.0421;
        } else {
          let index = 0;
          while (index < app.data.endpoints.length) {
            const { lat, lon } = app.data.endpoints[index];

            if (lat < latMin) latMin = lat;
            if (lat > latMax) latMax = lat;
            if (lon < lonMin) lonMin = lon;
            if (lon > lonMax) lonMax = lon;

            index += 1;
          }

          latDelta = 1.4 * (latMax - latMin);
          lonDelta = 1.4 * (lonMax - lonMin);
        }
      }
      latAvg = (latMin + latMax) / 2.0;
      lonAvg = (lonMin + lonMax) / 2.0;
    }

    return {
      travelType: (app.data && app.data.travelType !== undefined) ? app.data.travelType : 0,
      latAvg,
      lonAvg,
      latDelta,
      lonDelta,
      publisher,
      endpointsOrdered,
    };
  }

  constructor(props, context) {
    super(props, context);

    this.displayName = 'Purchase';

    this.onPayment = this.onPayment.bind(this);
    this.onPaymentStart = this.onPaymentStart.bind(this);
    this.onPaymentFailure = this.onPaymentFailure.bind(this);

    const { app, match: { params: { method } } } = this.props;
    const stateUpdates = app ? Purchase.updateStateOnAppChanges(app) : {};

    let selectedMethod = 0;
    if (method) {
      methods.forEach((m, idx) => {
        if (m.name === method) {
          selectedMethod = idx;
        }
      });
    }

    this.state = {
      toBuy: true,
      boundsSet: false,
      loading: false,
      ...stateUpdates,
      selectedMethod,
    };
  }

  static getDerivedStateFromProps(nextProps, _prevState) {
    if (nextProps.app) {
      return Purchase.updateStateOnAppChanges(nextProps.app);
    }
    return {};
  }

  onPaymentStart() {
    this.setState({ loading: true });
  }

  onPayment(type, pl) {
    const {
      app, history, onCreatePaidLease, match: { params: { native } },
    } = this.props;

    console.log('native');
    console.log(native);

    if (pl !== undefined) {
      const payload = pl;
      payload.version = version;

      onCreatePaidLease(type, JSON.stringify(payload))
        .then((_result) => {
          console.log('paid lease created');
          if (native && native === 'true') {
            console.log('navigate 1');
            window.location.href = `aionrails://ai-agent/online/${app.data.uuid}`;
          } else {
            console.log('navigate 2');
            history.push(`/ai-agent/online/${app.data.uuid}`);
          }
        })
        .catch((err) => {
          console.log('paid lease creation failed');
          console.log(err);
          this.setState({ loading: false });
        });
    } else if (native && native === 'true') {
      history.log('navigate 3');
      window.location.href = `aionrails://ai-agent/online/${app.data.uuid}`;
    } else {
      console.log('navigate 4');
      history.push(`/ai-agent/online/${app.data.uuid}`);
    }
  }

  onPaymentFailure() {
    this.setState({ loading: false });
    Alert.alert(
      translate('error'),
      translate('payment_failed'),
      [
        {
          text: translate('ok'),
        },
      ]
    );
  }

  onMapReady(m) {
    console.log('onMapReady');
    // console.log(m); // web debugging only: hangs on iOS
    if (m === null || m === undefined) {
      return;
    }

    const {
      boundsSet, latAvg, lonAvg, latDelta, lonDelta,
    } = this.state;

    if (boundsSet) {
      return;
    }
    this.setState({ boundsSet: true });

    const bounds = {
      south: latAvg - latDelta / 1.8,
      west: lonAvg - lonDelta / 1.8,
      north: latAvg + latDelta / 1.8,
      east: lonAvg + lonDelta / 1.8,
    };

    console.log(bounds);
    m.fitBounds(bounds);
  }

  render() {
    const {
      direction,
      app,
      existingLease,
      history,
      userData,
      user,
    } = this.props;
    const {
      latAvg,
      lonAvg,
      latDelta,
      lonDelta,
      loading,
      publisher,
      endpointsOrdered,
      toBuy,
    } = this.state;
    let {
      selectedMethod,
    } = this.state;

    if (!app || !app.data || !userData || !user) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    if (app && app.data && app.data.preview) {
      // if it's a preview, then we don't need to purchase it
      history.push(`/ai-agent/${app.data.uuid}`);
      return (<></>);
    }

    if (existingLease) {
      // TODO(clairbee): What do we do if we ended up here when we already have a lease? we can't blindly navigate away as it sometimes happen right after the purchase is complete.
      // history.push(`/ai-agent/online/${app.data.uuid}`);
      return (<></>);
    }

    if (methods.length === 1) {
      selectedMethod = 0;
    }

    const RentComponent = methods[selectedMethod].component(app.data.rentPrice, app.data.currency, userData.country, this.onPaymentStart, this.onPayment, this.onPaymentFailure, 1, app.data.promoted, app.data.uuid);
    const BuyComponent = methods[selectedMethod].component(app.data.buyPrice, app.data.currency, userData.country, this.onPaymentStart, this.onPayment, this.onPaymentFailure, 2, app.data.promoted, app.data.uuid);

    return (
      <View
        style={[styles.view.headed, {
          marginBottom: 0,
          paddingBottom: 0,
          ...ifIphoneX({
            paddingTop: 32,
          }),
        }]}
      >
        <View
          style={[styles.view.form, {
            flexDirection: direction,
          }]}
        >
          {/* the left column or the top header */}
          {direction === 'row' && (
            // <KeyboardAwareScrollView
            <View
              style={{
                flex: 1,
                flexDirection: 'column',
                height: '100%',

                // borderColor: 'red',
                // borderWidth: 1,
              }}
            >
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                }}
              >
                <div>MapView was here.</div>
                <PublisherBadge
                  style={{
                    marginHorizontal: 10,
                    marginBottom: 10,
                  }}
                  publisher={publisher}
                />
                <AppBadge
                  nopromo
                  style={{
                    marginHorizontal: 10,
                    marginBottom: 10,
                  }}
                  data={app.data}
                />
              </View>
            </View>
            // </KeyboardAwareScrollView>
          )}

          {/* the right column or the top header */}
          <View
            style={{
              flex: 1,
              flexDirection: 'column',
            }}
          >
            <KeyboardAwareScrollView
              style={{
                flex: 1,
              }}
              contentContainerStyle={{
                padding: 20,
                // justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                justifyContent: 'flex-start',
              }}
            >
              {direction !== 'row' && (
                <>
                  {/* <PublisherBadge
                    style={{
                      marginHorizontal: 10,
                      marginBottom: 10,
                    }}
                    publisher={publisher}
                  /> */}
                  <AppBadge
                    nopromo
                    style={{
                      marginHorizontal: 10,
                      marginBottom: 10,
                    }}
                    data={app.data}
                  />
                </>
              )}
              {methods.length > 1 && (
                <>
                  <Text
                    style={{
                      fontSize: 16,
                    }}
                  >
                    {translate('purchase_method')}
                  </Text>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {methods.map((m, idx) => (
                      <TouchableOpacity
                        style={[{
                          margin: 20,
                        }, selectedMethod === idx ? {
                          borderColor: styles.primaryColor,
                          borderWidth: 2,
                          borderRadius: 4,
                          shadowColor: '#333',
                          shadowRadius: 8,
                        } : {
                        }]}
                        onPress={() => this.setState({ selectedMethod: idx })}
                      >
                        <Image
                          style={{
                            height: selectedMethod !== undefined ? 30 : 60,
                            width: selectedMethod !== undefined ? 50 : 100,
                          }}
                          source={m.logo}
                          resizeMode="contain"
                        />
                      </TouchableOpacity>
                    ))}
                  </View>
                </>
              )}
              {selectedMethod !== undefined && (
                <View
                  style={{
                    flex: 1,
                    borderTopWidth: 1,
                    borderColor: '#333',
                  }}
                >
                  {loading ? (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <ActivityIndicator size="large" color={styles.primaryColor} />
                    </View>
                  ) : (() => {
                    switch (app.data.type) {
                      case 1: // rent only
                        return (
                          <>
                            <Text>
                              {translate('purchase_rent', { days: app.data.rentDays })}
                            </Text>
                            <RentComponent />
                          </>
                        );

                      case 2: // buy only
                        return (
                          <>
                            <Text>
                              {translate('purchase_buy')}
                            </Text>
                            <BuyComponent />
                          </>
                        );

                      case 3: // rent or buy
                        return (
                          <>
                            <View
                              style={{
                                borderBottomWidth: 1,
                                borderColor: '#333',
                                alignItems: 'stretch',
                              }}
                            >
                              <CheckBox
                                title={translate('purchase_buy')}
                                checkedIcon="dot-circle-o"
                                uncheckedIcon="circle-o"
                                checked={toBuy}
                                onPress={() => this.setState({ toBuy: true })}
                              />
                              <CheckBox
                                title={translate('purchase_rent', { days: app.data.rentDays })}
                                checkedIcon="dot-circle-o"
                                uncheckedIcon="circle-o"
                                checked={!toBuy}
                                onPress={() => this.setState({ toBuy: false })}
                              />
                            </View>
                            {toBuy ? (
                              <BuyComponent />
                            ) : (
                              <RentComponent />
                            )}
                          </>
                        );

                      default:
                        return (
                          <Text>Internal error #1</Text>
                        );
                    }
                  })()}
                </View>
              )}
            </KeyboardAwareScrollView>
            <View style={{
              backgroundColor: 'white',
              width: '100%',
              justifyContent: 'center',
              flexDirection: 'row',
              ...ifIphoneX({
                paddingBottom: 10,
              }),
            }}
            >
              <Button
                title={translate('button_cancel')}
                containerStyle={styles.button.secondaryContainer}
                buttonStyle={styles.button.secondary}
                titleStyle={styles.button.secondaryTitle}
                loading={loading}
                onPress={() => {
                  history.push(`/ai-agent/${app.data.uuid}`);
                }}
              />
              {/* <Button
                title={translate('button_purchase')}
                containerStyle={styles.button.primaryContainer}
                buttonStyle={styles.button.primary}
                disabledStyle={styles.button.primaryDisabled}
                titleStyle={styles.button.primaryTitle}
                disabledTitleStyle={styles.button.primaryTitleDisabled}
                loading={loading}
                disabled
                onPress={() => {
                  this.setState({ loading: true });
                  // FIXME(clairbee): complete this
                  // history.push(`/ai-agent/online/${app.data.uuid}`);
                }}
              /> */}
            </View>
          </View>
        </View>
      </View>
    );
  }
}

Purchase.defaultProps = {
  // TODO(clairbee): Even though 'app' is always supplied, we need a temporary value before graphql finishes loading
  app: null,
  userData: null,
  match: { params: { method: 'paypal', native: 'false' } },
};

Purchase.propTypes = {
  app: PropTypes.instanceOf(App),
  match: ReactRouterPropTypes.match.isRequired,
  existingLease: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
  onCreatePaidLease: PropTypes.func.isRequired,
  userData: AORTypes.User, // can't be 'isRequired' because of 'skip'
};

export default compose(
  graphql(GetApp, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientUnauthenticated,
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only',
    }),
    client: AppSyncClientUnauthenticated,
  }),
  graphql(CheckMyLease, {
    props: (props) => ({
      existingLease: props.data.checkMyLease,
    }),
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid, // This converts 'client.query()' variables into the query parameters
      },
      client: AppSyncClientAuthenticated(props.user),
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only',
    }),
    // client: AppSyncClientAuthenticated(),
  }),
  graphql(CreatePaidLease, {
    // name: 'CreatePaidLease',
    props: (props) => ({
      onCreatePaidLease: (type, payload) => props.mutate({
        variables: {
          uuid: props.ownProps.match.params.uuid,
          type,
          payload,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   existingLease:{...}}
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: CheckMyLease,
        variables: {
          uuid: props.match.params.uuid,
        },
        client: AppSyncClientAuthenticated(props.user),
      }, {
        query: QueryMyLeases,
        client: AppSyncClientAuthenticated(props.user),
      }],
      fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(Purchase);
